export default {
  data() {
    return {
      /**
       * Minimum width to avoid squashing the datepicker on mobile.
       *
       * Squashing appears when the datepicker is wrapped by a v-menu.
       * Especially visible on the iPhone 5, where the v-menu's 80%
       * max-width is lower than the v-date-picker's 290px default width.
       *
       * Apply this on the wrapping menu like:
       *   :min-width="mobileDatepickerMinWidth"
       */
      mobileDatepickerMinWidth: 290,
    };
  },
};



// WEBPACK FOOTER //
// ./src/mixins/mobileDatepickerMinWidth.js